import { Request, Response } from "express"

import { getUsersByAppID } from "../services/users.js"
import log from "../log.js"

export const routeGetUsers = async (req: Request, res: Response) => {
	log(`routeGetUsers`)

	const { appID } = req.query
	const users = await getUsersByAppID({
		app_id: appID as string,
	})

	res.json(users)
}
